export default __webpack_public_path__ + "static/pay-3-2d29b2ae9d2d79cde8735c2dccd4cc18.png";